var _defs, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamePieceCherries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80mm",
    height: "80mm",
    viewBox: "0 0 226.7717 226.7717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#db004f;}.b{fill:#004743;}.c{fill:#54ef9a;}.d{fill:#ebe1d8;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 155.0942,
    cy: 153.56,
    r: 39.9728
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M155.0935,195.2412a41.6811,41.6811,0,1,1,41.6819-41.6819A41.7288,41.7288,0,0,1,155.0935,195.2412Zm0-79.9448a38.2638,38.2638,0,1,0,38.2644,38.2629A38.3067,38.3067,0,0,0,155.0935,115.2964Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 87.7321,
    cy: 159.901,
    r: 37.0708,
    transform: "translate(-87.371 108.8699) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.7315,198.68a38.7794,38.7794,0,1,1,38.78-38.7784A38.8216,38.8216,0,0,1,87.7315,198.68Zm0-74.1415a35.3622,35.3622,0,1,0,35.363,35.3631A35.4026,35.4026,0,0,0,87.7315,124.5387Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.9018,83.0314c-15.6084,21.7332-47.1992,25.75-47.1992,25.75S25.4178,77.563,41.0262,55.83,88.2253,30.08,88.2253,30.08,94.51,61.2985,78.9018,83.0314Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.2933,110.44a1.7084,1.7084,0,0,1-1.2659-1.3215c-.263-1.3042-6.25-32.2018,9.6114-54.285C55.4976,32.7481,86.69,28.5517,88.01,28.3844a1.71,1.71,0,0,1,1.8907,1.3573c.262,1.304,6.2483,32.2032-9.6107,54.2852h0c-15.86,22.0853-47.0523,26.2819-48.3725,26.4491A1.6951,1.6951,0,0,1,31.2933,110.44ZM86.8211,32.0368c-6.565,1.173-31.4136,6.6979-44.407,24.7888-12.9919,18.0911-10.2912,43.4005-9.3061,49.9982,6.5663-1.1744,31.4148-6.6993,44.4054-24.7891h0C90.5238,63.9206,87.81,38.6287,86.8211,32.0368Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.6026,86.3379a1.6908,1.6908,0,0,1-.5861-.27,1.709,1.709,0,0,1-.3924-2.3846l39.2133-54.6a1.7089,1.7089,0,0,1,2.7769,1.9924l-39.2133,54.6A1.7083,1.7083,0,0,1,48.6026,86.3379Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.5087,78.0552a1.7054,1.7054,0,0,1-1.2758-1.3826l-2.5956-15.82a1.7081,1.7081,0,1,1,3.3712-.5525l2.5957,15.82a1.7074,1.7074,0,0,1-1.41,1.9619A1.6783,1.6783,0,0,1,68.5087,78.0552Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M155.0935,128.2965a1.7091,1.7091,0,0,1-1.7087-1.7c-.257-49.9065-15.2211-93.4686-65.141-94.8086A1.709,1.709,0,0,1,88.289,28.37h2.1756c20.0553,0,34.55,7.4179,46.4776,21.41,16.7081,19.6,19.7331,51.969,19.86,76.8a1.7085,1.7085,0,0,1-1.7,1.7169Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M89.5229,136.2466a1.7358,1.7358,0,0,1-.5006-.2179,1.71,1.71,0,0,1-.5122-2.3623,94.2761,94.2761,0,0,0,.2132-101.4449,1.7083,1.7083,0,0,1,2.88-1.8384,97.7029,97.7029,0,0,1-.2188,105.1334A1.7115,1.7115,0,0,1,89.5229,136.2466Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.89,137.529a11.703,11.703,0,0,1-9.8082-5.1093,1.7077,1.7077,0,0,1,2.8367-1.9023c2.5964,3.8679,8.0728,4.7555,12.211,1.9807a1.7076,1.7076,0,0,1,1.9021,2.8365A12.8051,12.8051,0,0,1,90.89,137.529Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.2492,130.1755a11.4364,11.4364,0,0,1-7.6507-2.8785,1.708,1.708,0,1,1,2.2661-2.5562,8.1113,8.1113,0,0,0,6.1771,1.9822,9.292,9.292,0,0,0,6.1355-3.1471,1.7093,1.7093,0,1,1,2.56,2.2661,12.7059,12.7059,0,0,1-8.3915,4.285Q154.7946,130.1747,154.2492,130.1755Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M79.2848,148.6229a8.0482,8.0482,0,1,1-8.0481-8.0481A8.0482,8.0482,0,0,1,79.2848,148.6229Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.7315,140.5748a8.0483,8.0483,0,1,1-8.0483-8.0483A8.0481,8.0481,0,0,1,147.7315,140.5748Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePieceCherries);
export default __webpack_public_path__ + "static/media/GamePiece - Cherries.bbfb8f9d4e07e36be48023e9c95475f9.svg";
export { ForwardRef as ReactComponent };